<template>
    <div class="box-container">
        <div class="company-content">
            <img :src="logo" alt="">
            <div class="sys-box">
                <p>土建专业虚拟仿真平台</p>
                <p>土建专业智能化考试系统</p>
                <p>武汉真道智享科技有限公司</p>
            </div>
            <div class="brief-box">
                <p>联系电话：027-87383569</p>
                <p>手机号：13667260026</p>
                <p>QQ：2407251293</p>
                <p>公司地址：湖北省武汉市洪山区珞喻路609号联合国际510室</p>
            </div>
            <div class="chat">
                <p>官方微信</p>
                <img src="../../assets/image/home/code.png" alt="" class="qr-code">
            </div>
        </div>
        <div class="copyright">
            <div>武汉真道智享科技有限公司</div>
            <div>教育信息化产品和服务供应商</div>
            <div>鄂ICP备20003251号-1Copyright ©2002-2021 武汉真道智享科技有限公司 版权所有</div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                logo:require('../../assets/image/logo2.png'),
            }
        }
    }
</script>

<style lang="less" scoped>
.box-container{
    padding: 6rem 22rem;
    background-color: #000219;
    .company-content{
        display: flex;
        justify-content: space-between;
        color: #FFFFFF;
        font-size: 14px;
        img{
            height: 9rem;
            object-fit: cover;
        }
        .sys-box> :nth-child(n),.brief-box> :nth-child(n){
            margin-top: 2rem;
        }
        .sys-box> :nth-child(1),.brief-box> :nth-child(1){
            margin-top: 0;
        }
    }
}
.copyright{
    font-size: 14px;
    color: #999999;
    margin-top: 6rem;
    display: flex;
    column-gap: 3rem;
    white-space: normal;
}
.qr-code{
    width: 10rem;
    height: 10rem;
    margin-top: 1.7rem;
}
@media screen and (max-width:750px){
    .company-content{
        flex-direction: column;
        align-items: center;
        row-gap: 4rem;
    }
    .sys-box{
        text-align: center;
    }
    .brief-box,.chat{
        text-align: center;
        white-space: normal;
    }
    .box-container{
        padding: 6rem 2rem;
    }
    .copyright{
        flex-direction: column;
        row-gap: 1rem;
        text-align: center;
    }
}
</style>